import React from 'react';
import { Link } from 'react-router-dom';

function daysRemaining(dateStr) {
  return Math.ceil((new Date(dateStr).getTime() - Date.now()) / 86400000);
}

function badgeCls(days) {
  if (days <= 7) return 'bg-red-100 text-red-700';
  if (days <= 14) return 'bg-yellow-100 text-yellow-800';
  return 'bg-green-100 text-green-700';
}

export default function LicensesExpiring({ items = [], loading }) {
  const sorted = [...items].sort((a, b) => new Date(a.license_expiry) - new Date(b.license_expiry));

  return (
    <div className="bg-white border border-gray-100 rounded-2xl shadow-sm">
      <div className="flex justify-between items-center px-5 pt-4 pb-2 border-b-2 border-brand-primary">
        <h3 className="text-xs font-extrabold uppercase tracking-wider text-brand-secondary">
          Driver Licenses Expiring
        </h3>
        <Link to="/drivers" className="text-xs font-semibold text-brand-primary">
          View all →
        </Link>
      </div>
      <div className="px-5 py-3 space-y-2">
        {loading ? (
          <p className="text-xs text-gray-400 py-2">Loading...</p>
        ) : items.length === 0 ? (
          <p className="text-xs text-gray-400 py-2">No licenses expiring soon.</p>
        ) : (
          sorted.map((driver) => {
            const days = daysRemaining(driver.license_expiry);
            return (
              <div key={driver.id_no} className="flex items-center justify-between py-1 border-b border-gray-50 last:border-b-0">
                <span className="text-xs font-semibold text-brand-secondary truncate">{driver.name}</span>
                <span className={`text-[10px] font-bold px-2 py-0.5 rounded-full ml-2 shrink-0 ${badgeCls(days)}`}>
                  {days} days
                </span>
              </div>
            );
          })
        )}
      </div>
    </div>
  );
}
